import { Link } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
export default function TestimonialFive(){
    return(
        <section class="testimonial-area testimonial-area2 nav-style-1 pt-120 pb-60 pt-md-60 pt-xs-60 home-5">
			<div class="container">
				<div class="row">
					<div class="col-lg-6">
						<div class="core-feature-title text-md-start">
							<p class="lh-1 mb-10">Our Clients Say</p>
							<h2 class="sect-title">1000+ Active Reviews</h2>
						</div>
					</div>
				</div>

				<OwlCarousel items={3}  
			className="owl-theme testimonial-slide4"  
			loop 
			dots={false}
            autoplay={true}
            center={true}
			nav={true}
			navText={[
				'<span class="arrow prev"><i class="fal fa-long-arrow-left"></i></span>',
				'<span class="arrow next"><i class="fal fa-long-arrow-right"></i></span>'
			  ]}				  
			margin={30} >
				<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-men-1-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Mr. Phoenix</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
							<div class="author-img">
								<img src="assets/img/home-5/team-women-2-300x300.jpg" alt="Image" />
							</div>
							<div class="testimonial-text-wrapper2 text-center">
								<div class="author-box">
									<div class="author-content">
										<h6>Jennifer Lopez</h6>
										<p>-Head Of Idea</p>
									</div>
								</div>
								<h5 class="fs-20">“ Professional &amp; modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”</h5>
								<div class="rating mb-10">
									<Link to="#"><i class="fas fa-star"></i></Link>
									<Link to="#"><i class="fas fa-star"></i></Link>
									<Link to="#"><i class="fas fa-star"></i></Link>
									<Link to="#"><i class="fas fa-star"></i></Link>
									<Link to="#"><i class="fas fa-star"></i></Link>
								</div>
							</div>
						</div>
						<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-men-3-100x100.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Robert Sojib</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-women-1-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Ariana Grande</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-men-1-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Mr. Phoenix</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-women-2-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Jennifer Lopez</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-men-3-100x100.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Robert Sojib</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-women-1-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Ariana Grande</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-men-1-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Mr. Phoenix</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="author-img">
							<img src="assets/img/home-5/team-women-2-300x300.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2 text-center">
							<div class="author-box">
								<div class="author-content">
									<h6>Jennifer Lopez</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<h5 class="fs-20">“ Professional &amp; modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div class="rating mb-10">
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
								<Link to="#"><i class="fas fa-star"></i></Link>
							</div>
						</div>
					</div>
			</OwlCarousel>
			</div>
			</section>
				
    )
}